import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Checkbox,
  Chip,
} from "@mui/material";
import {
  Cancel,
  Check,
  KeyboardReturn,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Add } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getCacheData } from "../../services/CacheService";
import { getCrListaPrecio, saveCrListaPrecio } from "../../services/CrListaPrecioService";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import RangoDialog from "./RangoDialog.jsx";
import { formatMoney } from "../../utils/utils";

const initialState = {
  id: null,
  idProveedor: null,
  idCristalProducto: null,
  idBlCrAdiciones: [],
  idBlCrDiametros: [],
  rangosList: [],
  observaciones: "",
};

const nameItemsText = "Lista de Precios de Cristales";
//
// ##########################################################################
//
const ListaPrecioCristal = () => {
  const navigate = useNavigate();
  const params = useParams();
  const idCrLprecio = params.idCrLprecio;
  const _action = params.action;
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [listaPrecioData, setListaPrecioData] = useState(initialState);
  const [rangosList, setRangosList] = useState([]);
  const [openRangoDialog, setOpenRangoDialog] = useState(false);
  const [actionCrud, setActionCrud] = useState("");
  const [actionRangoDialog, setActionRangoDialog] = useState("");
  const [itemCrud, setItemCrud] = useState(initialState);
  const [titleComponent, setTitleComponent] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [cristalProductos, setCristalProductos] = useState([]);
  const [blCrDiametros, setBlCrDiametros] = useState([]);
  const [blCrAdiciones, setBlCrAdiciones] = useState([]);
  const adicionesUserChangedRef = useRef(false);
  const [valueACProveedor, setValueACProveedor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");
  const [valueACCristalProducto, setValueACCristalProducto] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACCristalProducto, setInputValueACCristalProducto] = useState("");
  const [valueACBlCrDiametro, setValueACBlCrDiametro] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrDiametro, setInputValueACBlCrDiametro] = useState("");
  const [valueACBlCrAdicion, setValueACBlCrAdicion] = useState([]);
  const [inputValueACBlCrAdicion, setInputValueACBlCrAdicion] = useState("");
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const adicionesOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...blCrAdiciones,
    ];
  }, [blCrAdiciones]);

  const tableColumns = [
    {
      field: "esfera_desde",
      headerName: "Desde Esfera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_desde);
      },
    },
    {
      field: "esfera_hasta",
      headerName: "Hasta Esfera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_hasta);
      },
    },
    {
      field: "cilindro_desde",
      headerName: "Desde Cilindro",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_desde);
      },
    },
    {
      field: "cilindro_hasta",
      headerName: "Hasta Cilindro",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_hasta);
      },
    },
    {
      field: "costo_real",
      headerName: "Costo Real",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.costo_real);
      },
    },
    {
      field: "precio_venta_contado",
      headerName: "PV Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_contado);
      },
    },
    {
      field: "precio_venta_lista",
      headerName: "PV Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_lista);
      },
    },
    {
      field: "tiempo_entrega",
      headerName: "Tiempo de Entrega",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tiempo_entrega;
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 180,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {["new", "update"].includes(_action) && (
            <>
              <Tooltip title="editar rango">
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => handleClickRango(params.row, "update")}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="eliminar rango">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickRango(params.row, "delete")}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          )}

          {["enable", "disable", "mark-as-reference"].includes(_action) && (
            <Tooltip title="ver rango">
              <IconButton
                size="small"
                aria-label="view"
                onClick={() => handleClickRango(params.row, "view")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id_articulo || row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ##########################################################################
  //
  const allAdicionesSelected = useMemo(() => {
    return (
      Array.isArray(blCrAdiciones) &&
      blCrAdiciones.length > 0 &&
      Array.isArray(valueACBlCrAdicion) &&
      valueACBlCrAdicion.length === blCrAdiciones.length
    );
  }, [blCrAdiciones, valueACBlCrAdicion]);

  //
  // ##########################################################################
  //
  const handleSelectAllAdiciones = () => {
    if (Array.isArray(blCrAdiciones) && blCrAdiciones.length > 0) {
      setValueACBlCrAdicion(blCrAdiciones);
    }
  };
  //
  // ##########################################################################
  //
  const handleClearAllAdiciones = () => {
    setValueACBlCrAdicion([]);
  };
  //
  // ##########################################################################
  //
  useEffect(() => {
    setActionCrud(_action);
    loadCristalProductos();
    loadProveedores();
    loadBlCrAdiciones();
    loadBlCrDiametros();

    if (_action === "new") {
      setTitleComponent("Nueva " + nameItemsText);
    } else {
      load();
    }
  }, []);
  //
  // ##########################################################################
  //
  useEffect(() => {
    if (adicionesUserChangedRef.current) return;
    if (
      (_action === "update" || _action === "disable" || _action === "view" || _action === "enable" || _action === "mark-as-reference") &&
      Array.isArray(blCrAdiciones) &&
      blCrAdiciones.length > 0
    ) {
      const sourceList =
        (listaPrecioData && (listaPrecioData.adiciones_list)) ||
        [];
      if (Array.isArray(sourceList) && sourceList.length > 0) {
        const selectedIds = sourceList
          .map((it) => {
            if (it && typeof it === "object") {
              return it.id_bl_cr_adicion || it.id;
            }
            return it;
          })
          .filter(Boolean);
        const selectedOptions = blCrAdiciones.filter((opt) => selectedIds.includes(opt.id));
        if (selectedOptions.length > 0) {
          setValueACBlCrAdicion(selectedOptions);
          return;
        }
      }
      if (listaPrecioData && listaPrecioData.idBlCrAdiciones) {
        const selected = blCrAdiciones.find((opt) => opt.id === listaPrecioData.idBlCrAdiciones);
        if (selected) {
          setValueACBlCrAdicion([selected]);
        }
      }
    }
  }, [_action, listaPrecioData, blCrAdiciones]);
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/cr-lprecio-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setListaPrecioData({
      ...listaPrecioData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleClickRango = (itemCrud, parAction) => {
    let _itemCrud = {};
    _itemCrud = {
      id: itemCrud.id,
      idCrLprecio: itemCrud.id_cr_lprecio,
      esferaDesde: itemCrud.esfera_desde,
      esferaHasta: itemCrud.esfera_hasta,
      cilindroDesde: itemCrud.cilindro_desde,
      cilindroHasta: itemCrud.cilindro_hasta,
      costoPesos: itemCrud.costo_pesos ? (itemCrud.costo_pesos).toFixed(2) : 0,
      costoDolares: itemCrud.costo_dolares ? (itemCrud.costo_dolares).toFixed(4) : 0,
      valorDolar: itemCrud.valor_dolar ? (itemCrud.valor_dolar).toFixed(2) : 0,
      porcentajeDescuento: itemCrud.porcentaje_descuento ? (itemCrud.porcentaje_descuento).toFixed(2) : 0,
      costoReal: itemCrud.costo_real ? (itemCrud.costo_real).toFixed(2) : 0,
      futContado: itemCrud.fut_contado ? (itemCrud.fut_contado).toFixed(0) : 0,
      precioVentaContado: itemCrud.precio_venta_contado ? (itemCrud.precio_venta_contado).toFixed(2) : 0,
      futLista: itemCrud.fut_lista ? (itemCrud.fut_lista).toFixed(0) : 0,
      precioVentaLista: itemCrud.precio_venta_lista ? (itemCrud.precio_venta_lista).toFixed(2) : 0,
      tiempoEntrega: itemCrud.tiempo_entrega ? (itemCrud.tiempo_entrega).toFixed(0) : 0,
    };
    setActionRangoDialog(parAction);
    setItemCrud(_itemCrud);
    setOpenRangoDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleSave = async (parAction) => {
    let object = {};
    if (
      valueACProveedor.id === "" ||
      valueACProveedor.id === null ||
      valueACProveedor.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar el Proveedor",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      valueACCristalProducto.id === "" ||
      valueACCristalProducto.id === null ||
      valueACCristalProducto.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar el Producto",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      valueACBlCrDiametro.id === "" ||
      valueACBlCrDiametro.id === null ||
      valueACBlCrDiametro.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar el Diámetro",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    const selectedAdicionesCount = Array.isArray(valueACBlCrAdicion) ? valueACBlCrAdicion.length : 0;
    const existingAdicionesCount = (listaPrecioData.adicionesList && listaPrecioData.adicionesList.length) || (listaPrecioData.idBlCrAdiciones && listaPrecioData.idBlCrAdiciones.length) || 0;
    if (selectedAdicionesCount === 0 && existingAdicionesCount === 0) {
      setMessage({
        messageText: "Debes seleccionar al menos una Adición",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (rangosList.length === 0) {
      setMessage({
        messageText: "Debes agregar al menos un Rango a la Lista de Precios",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    object = {
      id: listaPrecioData.id,
      adicionesList: valueACBlCrAdicion.map(a => ({
        id_bl_cr_adicion: a.id,
      })),
      idBlCrDiametro: valueACBlCrDiametro.id,
      idCristalProducto: valueACCristalProducto.id,
      idProveedor: valueACProveedor.id,
      observaciones: (listaPrecioData.observaciones || "").toUpperCase(),
      rangosList: (rangosList || []).map(r => ({
        cilindro_desde: r.cilindro_desde,
        cilindro_hasta: r.cilindro_hasta,
        costo_dolares: r.costo_dolares,
        costo_pesos: r.costo_pesos,
        costo_real: r.costo_real,
        esfera_desde: r.esfera_desde,
        esfera_hasta: r.esfera_hasta,
        fut_contado: r.fut_contado,
        fut_lista: r.fut_lista,
        porcentaje_descuento: r.porcentaje_descuento,
        precio_venta_contado: r.precio_venta_contado,
        precio_venta_lista: r.precio_venta_lista,
        tiempo_entrega: r.tiempo_entrega,
        valor_dolar: r.valor_dolar,
      })),
    }
    setIsDoingSomething(true);
    const response = await saveCrListaPrecio(parAction, object);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        handleCancelar();
      }, 1000);
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getCrListaPrecio({ id: idCrLprecio });
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      if (_action === "update") {
        setTitleComponent("Editando " + nameItemsText);
      } else if (_action === "disable") {
        setTitleComponent("Deshabilitando " + nameItemsText);
      } else if (_action === "enable") {
        setTitleComponent("Habilitando " + nameItemsText);
      } else if (_action === "mark-as-reference") {
        setTitleComponent("Marcando como Lista de Precios de Referencia ");
      }

      setValueACProveedor({
        id: _response.id_proveedor,
        label: _response.descripcion_proveedor + (_response.contacto_proveedor ? " - " + _response.contacto_proveedor : ""),
      });
      setValueACCristalProducto({
        id: _response.id_cristal_producto,
        label: _response.descripcion_cristal_producto,
      });
      setValueACBlCrDiametro({
        id: _response.id_bl_cr_diametro,
        label: _response.valor_bl_cr_diametro === 0
          ? "0"
          : (_response.valor_bl_cr_diametro != null ? Number(_response.valor_bl_cr_diametro).toFixed(0) : ""),
      });
      setValueACBlCrAdicion(_response.id_bl_cr_adicion ? [{
        id: _response.id_bl_cr_adicion,
        // cuando el valor es 0, se debe mostrar como 0.00
        label: _response.valor_bl_cr_adicion === 0
          ? "0.00"
          : (_response.valor_bl_cr_adicion != null ? Number(_response.valor_bl_cr_adicion).toFixed(2) : ""),
      }] : []);
      setRangosList(Array.isArray(_response.rangos_list) ? _response.rangos_list : []);
      setListaPrecioData(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion + (item.contacto ? " - " + item.contacto : "")
        });
      });
      setProveedores(_var);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrAdiciones = async () => {
    const response = await getCacheData("bl_cr_adicion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCrAdiciones(_var);
    } else {
      setBlCrAdiciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCristalProductos = async () => {
    const response = await getCacheData("cristal_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCristalProductos(_var);
    } else {
      setCristalProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrDiametros = async () => {
    const response = await getCacheData("bl_cr_diametro");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(0),
        });
      });
      setBlCrDiametros(_var);
    } else {
      setBlCrDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseRango = () => {
    setOpenRangoDialog(false);
    setActionRangoDialog("");
  }
  //
  // ################################################################################
  //
  const handleSaveRango = (item, parAction) => {

    if (parAction === "delete") {
      // busco el cristal por su idCristalProducto y lo quito de la lista
      const _varList = (rangosList || []).filter((rango) => rango.id !== item.id);
      setRangosList(_varList);
      setOpenRangoDialog(false);
      return;
    }
    // normalizo el objeto que viene del diálogo a la forma usada en la tabla/estado
    const _normalized = {
      id: item.id,
      esfera_desde: item.esfera_desde,
      esfera_hasta: item.esfera_hasta,
      cilindro_desde: item.cilindro_desde,
      cilindro_hasta: item.cilindro_hasta,
      costo_pesos: item.costo_pesos,
      costo_dolares: item.costo_dolares,
      valor_dolar: item.valor_dolar,
      porcentaje_descuento: item.porcentaje_descuento,
      costo_real: item.costo_real,
      fut_contado: item.fut_contado,
      precio_venta_contado: item.precio_venta_contado,
      fut_lista: item.fut_lista,
      precio_venta_lista: item.precio_venta_lista,
      tiempo_entrega: item.tiempo_entrega,
    };

    if (parAction === "update") {
      const _list = rangosList ? [...rangosList] : [];
      const idx = _list.findIndex((rango) => rango.id === item.id);
      if (idx >= 0) {
        _list[idx] = _normalized;
      } else {
        _list.push(_normalized);
      }
      setRangosList(_list);
    } else if (parAction === "new") {
      const _list = rangosList ? [...rangosList] : [];
      _list.push(_normalized);
      setRangosList(_list);
    }
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={1} sx={{
        borderStyle: "solid",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        p: 1,
        m: 1,
        maxWidth: "100%"
      }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ m: 1, mb: 3 }}
            >
              <Typography variant="h5" display="block" gutterBottom >
                {titleComponent}
              </Typography>
            </Box>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12} lg={6}>
              <Autocomplete
                id="id-proveedor"
                size="small"
                value={
                  valueACProveedor && valueACProveedor.id
                    ? valueACProveedor
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACProveedor(newValue);
                  setListaPrecioData({
                    ...listaPrecioData,
                    idProveedor: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACProveedor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACProveedor(newInputValue);
                }}
                options={proveedores}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Proveedor" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
              />
            </Grid>

            <Grid item xs={12} lg={6}>
              <Autocomplete
                id="id-cristal-producto"
                size="small"
                value={
                  valueACCristalProducto && valueACCristalProducto.id
                    ? valueACCristalProducto
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACCristalProducto(newValue);
                  setListaPrecioData({
                    ...listaPrecioData,
                    idCristalProducto: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACCristalProducto}
                onInputChange={(event, newInputValue) => {
                  setInputValueACCristalProducto(newInputValue);
                }}
                options={cristalProductos}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Producto" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable"}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Autocomplete
                id="id-bl-cr-diametro"
                size="small"
                value={
                  valueACBlCrDiametro && valueACBlCrDiametro.id
                    ? valueACBlCrDiametro
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrDiametro(newValue);
                  setListaPrecioData({
                    ...listaPrecioData,
                    idBlCrDiametro: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrDiametro}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrDiametro(newInputValue);
                }}
                options={blCrDiametros}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Diámetro" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable" || actionCrud === "mark-as-reference"}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Autocomplete
                id="id-bl-cr-adicion"
                size="small"
                sx={{ width: "100%" }}
                multiple
                limitTags={5}
                openOnFocus
                disableCloseOnSelect // 
                value={valueACBlCrAdicion || []}
                onChange={(event, newValue, reason, details) => {
                  adicionesUserChangedRef.current = true;
                  const lastOption = details && details.option ? details.option : null;
                  if (lastOption && lastOption.__action) {
                    if (allAdicionesSelected) {
                      handleClearAllAdiciones();
                    } else {
                      handleSelectAllAdiciones();
                    }
                    return;
                  }
                  setValueACBlCrAdicion(newValue);
                }}
                inputValue={inputValueACBlCrAdicion}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrAdicion(newInputValue);
                }}
                options={adicionesOptionsWithActions}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.__action || value.__action) return option.id === value.id;
                  return option.id === value.id;
                }}
                getOptionLabel={(option) => option.label || ""}
                renderTags={(selected, getTagProps) => {
                  const visibleChips = 3;
                  const chips = selected.slice(0, visibleChips).map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id}
                      label={option.label}
                      size="small"
                    />
                  ));
                  if (selected.length > visibleChips) {
                    chips.push(
                      <Chip key="more" label={`+${selected.length - visibleChips}`} size="small" disabled />
                    );
                  }
                  return chips;
                }}
                disableClearable={true}
                disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable" || actionCrud === "mark-as-reference"}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  if (option.__action) {
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          indeterminate={
                            !allAdicionesSelected &&
                            Array.isArray(valueACBlCrAdicion) &&
                            valueACBlCrAdicion.length > 0
                          }
                          checked={allAdicionesSelected}
                          style={{ marginRight: 5 }}
                        />
                        {allAdicionesSelected ? "Desmarcar todos" : "Marcar todos"}
                      </li>
                    );
                  }
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 5 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => <TextField {...params} label="Adiciones" />}
              />
            </Grid>
          </Grid>

          {["new", "update"].includes(_action) && (
            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", ml: 1, mb: 2 }}
              >
                <Tooltip title="nuevo rango">
                  <span>
                    <Button
                      className="btn-add"
                      variant="contained"
                      onClick={() => handleClickRango({}, "new")}
                      startIcon={<Add />}
                    >
                      Rango
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </Grid>
          )}

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Rangos
                </Typography>
                <DataGrid
                  rows={rangosList}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={listaPrecioData.observaciones}
                onChange={handleChange}
                multiline
                rows={3}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px',
                    minWidth: '400px',
                  }
                }}
                disabled={["view", "enable", "disable"].includes(actionCrud)}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
            >
              {_action !== "view" && (
                <>
                  {["new", "update"].includes(_action) && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(_action)}
                      startIcon={<SaveIcon />}
                    >
                      Guardar
                    </Button>
                  )
                  }

                  {_action === "disable" && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(_action)}
                      startIcon={<RemoveCircleOutlineIcon />}
                    >
                      Deshabilitar
                    </Button>
                  )}

                  {_action === "enable" && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(_action)}
                      startIcon={<AddCircleOutlineIcon />}
                    >
                      Habilitar
                    </Button>
                  )}

                  {_action === "mark-as-reference" && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(_action)}
                      startIcon={<Check />}
                    >
                      Marcar como de Referencia
                    </Button>
                  )}

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelar}
                    startIcon={
                      _action === "view" ? <KeyboardReturn /> : <Cancel />
                    }
                  >
                    Cancelar
                  </Button>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Paper >

      {openRangoDialog && (
        <RangoDialog
          onSave={handleSaveRango}
          onClose={handleCloseRango}
          rangosList={rangosList}
          actionCrud={actionRangoDialog || actionCrud}
          itemCrud={itemCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ListaPrecioCristal;
